import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

const currentYear = computed(() => new Date().getFullYear())

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createBlock(_component_v_footer, {
    app: "",
    class: "modern-footer"
  }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "footer-background" }, null, -1)),
      _createVNode(_component_v_container, {
        style: {"justify-items":"center"},
        class: "footer-container"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "footer-content" }, null, -1)
        ])),
        _: 1,
        __: [0]
      })
    ]),
    _: 1,
    __: [1]
  }))
}
}

})